var qChoice = "Quilters Choice"
  , backingIncluded = "Included"
  , backingIncText = "I'm including my own backing"
  , selectedPattern = null
  , selectedThread = qChoice
  , selectedBacking = null
  , fbyBackingQty = 0
  , selectedStitching = "no"
  , backStitchingPrice = 15
  , selectedBinding = "trim"
  , machineBindingPrice = 45
  , handBindingPrice = 105
  , trimmingPrice = 10
  , selectedExpOption = !1
  , validPatternMsg = "Please select a valid Pattern<br>"
  , validDimensionsMsg = "Please enter valid dimensions for your quilt (width and height) in inches<br>"
  , validBattingMsg = "Please choose your Batting<br>"
  , validBackingMsg = "Please make a selection for Backing<br>"
  , validTermsAgree = "Please agree to the terms<br>";
$(document).ready(function() {
    $("#colorwheel-select").colorwheel(),
    $("#width").change(function() {
        updatePrice(),
        updateBackingOptions()
    }),
    $("#height").change(function() {
        updatePrice(),
        updateBackingOptions()
    }),
    $("#pattern-select").click(function() {
        $("#pattern-select-dialog").removeClass("hidden")
    }),
    $("#close-pattern-dialog").click(function() {
        $("#pattern-select-dialog").addClass("hidden")
    }),
    $("li.pattern-option").each(function(index) {
        $(this).on("click", function() {
            selectedPattern = {
                name: $(this).attr("data-name"),
                image: $(this).attr("data-image"),
                price: $(this).attr("data-price"),
                variantId: $(this).attr("data-variant")
            },
            updatePrice(),
            $("#pattern-select-dialog").addClass("hidden"),
            $("#pattern-select-text").html("Selected Pattern:<br>" + selectedPattern.name),
            $("#selected-pattern-image").attr("src", selectedPattern.image),
            $("#selected-pattern-image").removeClass("hidden")
        })
    }),
    $("#thread-select").click(function() {
        $("#color-select-dialog").removeClass("hidden"),
        $(".colorPicker").show()
    }),
    $("#close-color-dialog").click(function() {
        $("#color-select-dialog").addClass("hidden")
    }),
    $(document).on("click", ".segment", function(event) {
        event.preventDefault(),
        $("#color-select-dialog").addClass("hidden");
        var colorValue = $("#colorwheel-select").colorwheel("value");
        selectedThread.name = colorValue.label,
        $("#thread-select-text").html("Selected Thread:<br>" + selectedThread),
        $("#selected-thread").css("background-color", "#" + colorValue.value),
        $("#selected-thread").removeClass("hidden"),
        $("#clear-thread").removeClass("hidden")
    }),
    $("#clear-thread").click(function() {
        selectedThread = qChoice,
        $("#thread-select-text").html(qChoice),
        $("#selected-thread").addClass("hidden"),
        $("#clear-thread").addClass("hidden")
    }),
    $("#batting-select").click(function() {
        $("#batting-select-dialog").removeClass("hidden")
    }),
    $("#close-batting-dialog").click(function() {
        $("#batting-select-dialog").addClass("hidden")
    }),
    $("#backing-select").click(function() {
        $("#backing-select-dialog").removeClass("hidden")
    }),
    $("#close-backing-dialog").click(function() {
        $("#backing-select-dialog").addClass("hidden")
    }),
    $("li.backing-option").each(function(index) {
        $(this).on("click", function() {
            selectedBacking = {
                name: $(this).attr("data-name"),
                image: $(this).attr("data-image"),
                price: $(this).attr("data-price"),
                variantId: $(this).attr("data-variant")
            },
            $("#backing-select-dialog").addClass("hidden"),
            updatePrice(),
            $("#backing-select-text").html("Selected Backing:<br>" + selectedBacking.name),
            $("#selected-backing-image").attr("src", selectedBacking.image),
            $("#selected-backing-image").removeClass("hidden"),
            $("#clear-backing").removeClass("hidden"),
            $("#back-stitching-select").addClass("hidden")
        })
    }),
    $("#clear-backing").click(function() {
        selectedBacking = backingIncluded,
        fbyBackingQty = 0,
        $("#backing-select-text").html(backingIncText),
        $("#clear-backing").addClass("hidden"),
        $("#selected-backing-image").addClass("hidden"),
        $("#back-stitching-select").removeClass("hidden"),
        updatePrice()
    });
    function updatePrice() {
        var width = +$("#width").val()
          , height = +$("#height").val()
          , price = width * height * .03;
        if (selectedBinding == "trim" ? price += trimmingPrice : selectedBinding == "machine" ? price += machineBindingPrice : selectedBinding == "hand" && (price += handBindingPrice),
        selectedBacking && selectedBacking != backingIncluded) {
            var max = Math.max(width, height);
            max += 5,
            max /= 36;
            var yards = Math.ceil(max / .25) * .25;
            fbyBackingQty = yards * 4;
            var backingCost = parseInt(selectedBacking.price) * fbyBackingQty / 100;
            price += backingCost
        } else
            selectedBacking && selectedStitching == "yes" && (price += backStitchingPrice);
        var expCost = width * height * .005;
        expCost < 25 && (expCost = 25),
        $("#expedite-cost").html("for $" + expCost.toFixed(2)),
        $("#expedite").is(":checked") && (price += expCost),
        $("#current_price").html("$" + price.toFixed(2))
    }
    function updateBackingOptions() {
        var width = +$("#width").val()
          , height = +$("#height").val();
        width <= 55 || height <= 55 ? ($("#backing-108").removeClass("hidden"),
        $("#backing-90").removeClass("hidden"),
        $("#backing-60").removeClass("hidden"),
        $("#dimension-error").addClass("hidden")) : width <= 85 || height <= 85 ? ($("#backing-108").removeClass("hidden"),
        $("#backing-90").removeClass("hidden"),
        $("#backing-60").addClass("hidden"),
        $("#dimension-error").addClass("hidden")) : width > 118 && height > 118 ? $("#dimension-error").removeClass("hidden") : ($("#backing-108").removeClass("hidden"),
        $("#backing-90").addClass("hidden"),
        $("#backing-60").addClass("hidden"),
        $("#dimension-error").addClass("hidden"))
    }
    $("input[type=radio][name=stitching]").change(function() {
        selectedStitching = this.value,
        updatePrice()
    }),
    $("input[type=checkbox][name=expedite]").change(function() {
        selectedExpOption = this.checked,
        updatePrice()
    }),
    $("input[type=radio][name=binding]").change(function() {
        this.value == "hand" ? $("#binding-detail").removeClass("hidden") : $("#binding-detail").addClass("hidden"),
        selectedBinding = this.value,
        updatePrice()
    });
    function validate(width, height) {
        var errMsg = "";
        return !(width > 0) && !(height > 0) ? errMsg = errMsg.concat(validDimensionsMsg) : selectedPattern == null ? errMsg = errMsg.concat(validPatternMsg) : selectedBacking == null ? errMsg = errMsg.concat(validBackingMsg) : document.getElementById("agree").checked || (errMsg = errMsg.concat(validTermsAgree)),
        errMsg
    }
    $("#add-to-cart").click(function() {
        var width = +$("#width").val()
          , height = +$("#height").val()
          , errMsg = validate(width, height)
          , bComments = $.trim($("#binding-textarea").val()) != "" ? $.trim($("#binding-textarea").val()) : "None"
          , items = [];
        if (errMsg == "") {
            if (items.push({
                quantity: width * height,
                id: 34861283901573,
                properties: {
                    "MQ Pattern": selectedPattern.name,
                    "MQ Thread": selectedThread,
                    "MQ Backing": selectedBacking.name,
                    "MQ Binding": selectedBinding,
                    "MQ BindingComments": bComments,
                    "MQ AdditionalComments": $.trim($("#comment-textarea").val()) ? $.trim($("#comment-textarea").val()) : "None",
                    "MQ Width (inches)": width,
                    "MQ Height (inches)": height
                }
            }),
            selectedExpOption) {
                var sqInches = width * height;
                if (sqInches < 5e3)
                    items.push({
                        quantity: 1,
                        id: 34867762626693,
                        properties: {
                            "MQ Note": "For MQ order",
                            "MQ Width (inches)": width,
                            "MQ Height (inches)": height
                        }
                    });
                else {
                    var qty = Math.floor(width * height / 2);
                    items.push({
                        quantity: qty,
                        id: 34861283934341,
                        properties: {
                            "MQ Pattern": selectedPattern.name,
                            "MQ Thread": selectedThread,
                            "MQ Backing": selectedBacking.name,
                            "MQ Binding": selectedBinding,
                            "MQ BindingComments": bComments,
                            "MQ AdditionalComments": $.trim($("#comment-textarea").val()) ? $.trim($("#comment-textarea").val()) : "None",
                            "MQ Width (inches)": width,
                            "MQ Height (inches)": height
                        }
                    })
                }
            }
            if (selectedBacking.price && fbyBackingQty > 0 && items.push({
                quantity: fbyBackingQty,
                id: selectedBacking.variantId,
                properties: {
                    "MQ Note": "For MQ order",
                    "MQ Backing": selectedBacking.name,
                    "MQ Width (inches)": width,
                    "MQ Height (inches)": height
                }
            }),
            selectedBacking == backingIncluded && selectedStitching == "yes" && items.push({
                quantity: 1,
                id: 34821461442693,
                properties: {
                    "MQ Note": "For MQ order",
                    "MQ BackStitching": selectedStitching,
                    "MQ Width (inches)": width,
                    "MQ Height (inches)": height
                }
            }),
            selectedBinding == "machine" || selectedBinding == "hand" || selectedBinding == "trim") {
                let bindingId = selectedBinding == "machine" ? 34799491776645 : selectedBinding == "hand" ? 34799491809413 : 39269086068869;
                items.push({
                    quantity: 1,
                    id: bindingId,
                    properties: {
                        "MQ Note": "For MQ order",
                        "MQ Binding": selectedBinding,
                        "MQ Width (inches)": width,
                        "MQ Height (inches)": height
                    }
                })
            }
            $.post("/cart/add.js", {
                items
            }),
            $("#error").html(""),
            $("#success").html("Added to cart!  <a href='/cart' class='underline'>View Cart</a>")
        } else
            $("#error").html(errMsg)
    });
    function getPropertyString(selectedProp) {
        var label = selectedProp.name;
        return selectedProp.price && (label = label.concat(" (extra $)")),
        label
    }
});
//# sourceMappingURL=/cdn/shop/t/39/assets/mqtest.js.map?v=89811404926096889591712837010
